// extracted by mini-css-extract-plugin
export default {"contentBlock":"vpNzYL9f0_pOr4cA_tku"};